import {StandardName} from "./order.state";

export interface QuestionGroup {
	type: QuestionGroupType;
	questions: Question[];
}

export interface Question {
	type: QuestionType;
	comment: string;
	answers: Answer[];
}

export interface Answer {
	standardName: StandardName;
	answer: boolean;
}

export enum QuestionType {
	// application review
	SCOPE_OF_CERTIFICATION = 'SCOPE_OF_CERTIFICATION',
	IAF_CODE_JUSTIFICATION = 'IAF_CODE_JUSTIFICATION',
	MULTIPLE_IAF_CODES = 'MULTIPLE_IAF_CODES',
	AUDIT_EFFORT = 'AUDIT_EFFORT',
	BUSINESS_COMPLEXITY = 'BUSINESS_COMPLEXITY',
	IT_COMPLEXITY = 'IT_COMPLEXITY',
	QMS_RISK = 'QMS_RISK',
	COMPLEXITY_FACTOR = 'COMPLEXITY_FACTOR',
	EMPLOYEE_COUNT_ACCURATE = 'EMPLOYEE_COUNT_ACCURATE',
	OFFSIDE_ACTIVITIES_PRESENT = 'OFFSIDE_ACTIVITIES_PRESENT',
	COMPANY_USES_CONSULTANT = 'COMPANY_USES_CONSULTANT',
	CONFLICT_OF_INTERESTS = 'CONFLICT_OF_INTERESTS',
	AUDITORS_WITH_NIAF_CODES = 'AUDITORS_WITH_NIAF_CODES',
	CALCULATED_DAYS_CORRECT = 'CALCULATED_DAYS_CORRECT',
	STAGE_1_AND_2_BACK_TO_BACK = 'STAGE_1_AND_2_BACK_TO_BACK',
	ADDITIONAL_RISKS = 'ADDITIONAL_RISKS',
	SITE_REQUIREMENTS_FOR_SAFETY = 'SITE_REQUIREMENTS_FOR_SAFETY',
	NOTES_FOR_CLIENT_SERVICES = 'NOTES_FOR_CLIENT_SERVICES',
	SIGNED_BY_OFFICER = 'SIGNED_BY_OFFICER',
	CONTAINS_CONFIDENTIAL_INFORMATION = 'CONTAINS_CONFIDENTIAL_INFORMATION',
	DEGREE_OF_CERT_IMPLEMENTATION = 'DEGREE_OF_CERT_IMPLEMENTATION',

	// client service
	CS_LEGAL_NAME = 'CS_LEGAL_NAME',
	CS_SCOPE_APPROPRIATE = 'CS_SCOPE_APPROPRIATE',
	CS_IAF_CODE_CORRECT = 'CS_IAF_CODE_CORRECT',
	CS_MULTIPLE_IAF_CODES_APPLICABLE = 'CS_MULTIPLE_IAF_CODES_APPLICABLE',
	CS_JUSTIFICATION_PROVIDED = 'CS_JUSTIFICATION_PROVIDED',
	CS_COMPLEXITY_FACTOR = 'CS_COMPLEXITY_FACTOR'
}

export enum QuestionGroupType {
	// application review
	APPLICANT_SCOPE_AND_OUTSOURCING = 'APPLICANT_SCOPE_AND_OUTSOURCING',
	CONFIDENTIALITY_AND_IMPARTIALITY = 'CONFIDENTIALITY_AND_IMPARTIALITY',
	AUDIT_TEAM = 'AUDIT_TEAM',
	AUDIT_TIME = 'AUDIT_TIME',
	ADDITIONAL = 'ADDITIONAL',

	// client service
	RENEWAL_CHECKLIST = 'RENEWAL_CHECKLIST'
}
